import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import Admin from '@/views/admin/Admin.vue';
import About from '@/views/About.vue';
import Todo from '@/views/Todo.vue';
import Login from '@/views/Login.vue';
import SignUp from '@/views/SignUp.vue';
import Profile from '@/views/Profile.vue';
import { useAuthStore } from '@/stores/auth';

// routeを定義
const routes = [
  {
    path: '/admin',
    name: 'Admin',
    meta: { requiresAuth: true, requiresAdmin: true, title: 'Admin', hideInMenu: false },
    component: Admin,
    children: [
      {
        path: 'user/:id',
        name: 'UserEdit',
        component: Profile,
        props: true,
      },
    ],
  },
  {
    path: '/',
    name: 'Home',
    meta: { requiresAuth: true, title: 'Home', hideInMenu: false },
    component: Home,
  },
  {
    path: '/about',
    name: 'About',
    meta: { title: 'About', hideInMenu: false },
    component: About,
  },
  {
    path: '/todo',
    name: 'Todo',
    meta: { requiresAuth: true, title: 'Todo', hideInMenu: false },
    component: Todo,
  },
  {
    path: '/login',
    name: 'Login',
    meta: { title: 'Login', hideInMenu: true },
    component: Login,
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp,
    meta: { title: 'SignUp', hideInMenu: true },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true, title: 'Profile', hideInMenu: false },
  },
];

// router作成
const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore();
  await auth.initPromise; //ストアの初期化完了を待つ

  const user = auth.user;
  const isAdmin = auth.isAdmin;

  console.log('router.boforeEach->isAdmin?', isAdmin);
  // 1. ログインしているかチェック
  if (to.meta.requiresAuth && !user) {
    return next({ name: 'Login' });
  }

  // 2. 管理者権限チェック
  if (to.path === '/admin') {
    if (isAdmin) {
      next();
    } else {
      console.log('管理者権限が必要です');
      next('/');
    }
    return;
  }

  // 3. URL のクリーンアップ (Google認証など)
  if (to.query.code) {
    const newQuery = { ...to.query };
    delete newQuery.code;
    return next({
      path: to.path,
      query: newQuery,
      replace: true,
    });
  }

  // 4. それ以外の通常ルート
  next();
});
export default router;
